import { Component, OnInit, OnDestroy, Input, Output, OnChanges, SimpleChange, SimpleChanges } from '@angular/core';
import { DataIoService } from '../../../services/data-io.service';
import { MenuService } from '../../../services/menu.service';
import { MenuNode } from '../../../classes/MenuNode';
import { BaseSensor } from '../../../classes/BaseSensor';
import { UnitConverter } from '../../../classes/UnitConverter';
@Component({
  selector: 'base-display',
  templateUrl: './base-display.component.html',
  styleUrls: ['./base-display.component.scss']
})
export class BaseDisplayComponent implements OnInit {
  @Input('sensor') sensor:BaseSensor = undefined;
  @Input('alignment') alignment:string = undefined;
  @Input('smallLetters') smallLetters:string=undefined;
  @Input('bigLetters') bigLetters:string=undefined;
  @Input('unit') unit:string=undefined;
  @Input('showScale') showScale : boolean = undefined;
  @Input('scaleElements') scaleElements : Array<number>;
  @Input('scaleValue') scaleValue : number;
  @Input('scaleType') scaleType:string;
	node: MenuNode=undefined;
  unitConverter:UnitConverter=undefined;
  constructor(private menuService:MenuService, private ioService: DataIoService) {
    this.unitConverter = new UnitConverter();

  }
  getClasses(){
    let classes = [];
    switch(this.alignment){
      case 'left':{
        classes.push('align-left');
        break;
      }
      case 'right':{

      }
      default:{
        classes.push('');
      }
    }
    return classes;
  }
  getScaleValue(){
    return this.scaleValue;
  }
  getScaleType(){
  	if(this.scaleType == undefined){
  		return 'default';
  	}
  	return this.scaleType;
  }
  getScaleElements(){
  	return this.scaleElements;
  }

  available_units = ['degC','bar','kW','kWh','kWhd','perc','lpm','h','seconds'];
  
  getBigLetters(){
    if(this.bigLetters){
      return this.bigLetters;
    }
    return '';
  }
  getSmallLetters(){
    if(this.smallLetters){
      return this.smallLetters;
    }
    return '';
  }

  getUnitClass(){
    return this.unitConverter.getClassName(this.unit);
  }
  
  hasScale(){
    let hs =  (this.showScale && (this.scaleElements != undefined || ![undefined,null].includes(this.scaleValue) ) ) || this.scaleType == 'loadinganimation';
    return hs;
  }
  
  getUnit(){
    return this.unitConverter.getSymbol(this.unit);
  }
  

  ngOnInit() {
    this.node = this.menuService.getCurrentNode();
    console.log("OnInit on BaseDisplay called on Node: "+this.node.getIdentifier());
  }
  
  ngOnDestroy(){
    console.log("OnDestroy on BaseDisplay called on Node: "+this.node.getIdentifier());
  }
  
  _isBlinking:boolean=false;
  
  isBlinking():boolean{
    return this._isBlinking;
  }
  
  _blinkHandler:any=undefined;

  stopBlinking(){
    if(this._blinkHandler){
      clearTimeout(this._blinkHandler);
    }
    this._blinkHandler = undefined;
    this._isBlinking = false;
  }
  blink(){
    this.stopBlinking();
    this._blinkHandler = setTimeout(()=>{
      this.stopBlinking();
    },2000);
    this._isBlinking = true;
  }
}
